import { render, staticRenderFns } from "./download_nm.vue?vue&type=template&id=6ff1a59c&scoped=true&"
import script from "./download_nm.vue?vue&type=script&lang=js&"
export * from "./download_nm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff1a59c",
  null
  
)

export default component.exports